import { t } from '../messages';
import { readEnvironmentInventory } from './inventory';
import './inventory.css';
const componentKeys: Record<string, Parameters<typeof t>[0]> = {
  'ultimate-addons-for-gutenberg': 'environments.inventory.name.spectra',
  'wordpress-seo': 'environments.inventory.name.yoast',
  ndrcbridge: 'environments.inventory.name.bridge',
  ps_checkpayment: 'environments.inventory.name.check',
  ps_sharebuttons: 'environments.inventory.name.share',
  productcomments: 'environments.inventory.name.comments',
  ps_mainmenu: 'environments.inventory.name.menu',
  ps_imageslider: 'environments.inventory.name.slider',
  ps_featuredproducts: 'environments.inventory.name.featured',
  ps_customtext: 'environments.inventory.name.text',
  blockreassurance: 'environments.inventory.name.reassurance',
  ps_linklist: 'environments.inventory.name.links',
};

const componentLabel = (name: string) => {
  const key = Object.hasOwn(componentKeys, name) ? componentKeys[name] : undefined;
  return key ? t(key) : name;
};
export function EnvironmentInventory({
  observed,
  expectedVersion,
}: {
  observed: unknown;
  expectedVersion?: string | null;
}) {
  const value = readEnvironmentInventory(observed);
  return (
    <details className="environment-inventory">
      <summary>{t('environments.inventory.title')}</summary>
      {!value ? (
        <p>{t('environments.inventory.missing')}</p>
      ) : (
        <>
          <p>{t('environments.inventory.hint')}</p>
          <dl>
            <div>
              <dt>{t('environments.inventory.software')}</dt>
              <dd>{value.version}</dd>
            </div>
            {expectedVersion && (
              <div>
                <dt>{t('environments.inventory.expected')}</dt>
                <dd>{expectedVersion}</dd>
              </div>
            )}
            {value.theme && (
              <div>
                <dt>{t('environments.inventory.theme')}</dt>
                <dd>
                  {value.theme}
                  {value.themeVersion ? ' · ' + value.themeVersion : ''}
                </dd>
              </div>
            )}
          </dl>
          {expectedVersion && value.version !== expectedVersion && (
            <p role="alert">{t('environments.inventory.difference')}</p>
          )}
          {value.components.length > 0 && (
            <div className="environment-inventory-table">
              <table>
                <thead>
                  <tr>
                    <th>{t('environments.inventory.component')}</th>
                    <th>{t('environments.inventory.version')}</th>
                    <th>{t('environments.inventory.state')}</th>
                  </tr>
                </thead>
                <tbody>
                  {value.components.map((c) => (
                    <tr key={c.name}>
                      <td>{componentLabel(c.name)}</td>
                      <td>{c.version ?? t('environments.inventory.unknown')}</td>
                      <td>
                        {t(
                          !c.installed
                            ? 'environments.inventory.absent'
                            : c.active
                              ? 'environments.inventory.active'
                              : 'environments.inventory.inactive',
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <p>{t('environments.inventory.scope')}</p>
        </>
      )}
    </details>
  );
}
